import { render, staticRenderFns } from "./lt-title.vue?vue&type=template&id=34a72af8&scoped=true&"
import script from "./lt-title.vue?vue&type=script&lang=js&"
export * from "./lt-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a72af8",
  null
  
)

export default component.exports